import { render, staticRenderFns } from "./UnitWindow.vue?vue&type=template&id=2b52b61c&"
import script from "./UnitWindow.vue?vue&type=script&lang=js&"
export * from "./UnitWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports